import React from 'react'

const ResponsePopup = (props) => {
    const {final_response, fail_response, initial_response} = props;
    return (
        <>
            <div className='menu menu-sub menu-sub-dropdown w-400px w-md-400px' data-sai-menu='true'>
                {
                    final_response !== '' &&
                    <div className="row px-6 p-3">
                        <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>
                                        Final Response
                                    </h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-12'>
                                    <span className="fw-semibold text-gray-600 fs-6 d-block">
                                       {final_response}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    initial_response !== '' &&
                    <div className="row px-6 p-3">
                        <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>
                                        Initial Response
                                    </h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-12'>
                                    <span className="fw-semibold text-gray-600 fs-6 d-block">
                                        {initial_response}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    fail_response !== '' &&
                    <div className="row px-6 p-3">
                        <div className="col-md-12 border border-dashed border-gray-400 rounded p-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>
                                        Fail Response
                                    </h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-12'>
                                    <span className="fw-semibold text-gray-600 fs-6 d-block">
                                        {fail_response}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default ResponsePopup